export const mSEPreviewImg = 
    { 
        src: "https://i.ibb.co/5rSQBsC/m-SEpreview.webp",
        alt: "Screencapture of AfterEffects extension tool with title Mini SparkEffects (mSE)."
    }

//email templates
export const leftAlignImg = {
    src: "https://i.ibb.co/SfkFFWS/emaillayouts-left-Align.webp",
    alt: "Email template displayed on a PC, Mac, and iPhone.",
};

export const salesEmailImg = { 
    src: "https://i.ibb.co/27DQWCq9/emaillayouts-sales.webp",
    alt: "Email template displayed on a PC, Mac, and iPhone.",
};

export const centeredImg = {
    src: "https://i.ibb.co/zhsyC5r/emaillayouts-centered.webp",
    alt: "Email template displayed on a PC, Mac, and iPhone.",
};

export const topBannerImg = {
    src: "https://i.ibb.co/R7Jd8ZC/emaillayouts-topbanner.webp",
    alt: "Email template displayed on a PC, Mac, and iPhone.",
};

//vibes emails
export const vibesImg = {
    src: "https://i.ibb.co/20STXbPR/vibes-Email-Layouts.webp",
    alt:  "Email template displayed on a Mac and iPhone."
};

//infographic experience
export const tvVersionImg =  {
    src: "https://i.ibb.co/yS0sLgs/tv-goalsetting.webp",
    alt: "Screenshot of a webpage with the title 'Today you are going to:', the subtitles 'set a personal goal', 'identify skills to grow', and 'establish a check-in schedule', each with corresponding symbols of a target, graph, and calendar. Below is a right arrow and a progress bar.",
};

//scrolling infographic
export const previewImg = {
    src: "https://i.ibb.co/HPbN7N9/preview-Img.webp",
    alt: 'Beginning frame of an infographic, with title text "See an Effective Goal in Action"',
};

//the Center
export const dogPageImg = {
    src: "https://i.ibb.co/3dQWwWS/dog-page.webp",
    alt: "Screenshot of a webpage showing several listings of adoptable dogs."
};

export const indivPageImg = {
    src: "https://i.ibb.co/KxQ6W1X/indiv-page.webp",
    alt: "Screenshot of a webpage showing images and description of a small dog named Dusty."
};

//voispark
export const boxUploaderImg = {
    src: "https://i.ibb.co/ZzXXnB2/box-Uploader-1.gif",
    alt: "Screencap of use of Box uploader UI in Voice Spark."
};

export const voisparkMainImg = {
    src: "https://i.ibb.co/YjqZrYy/voisparkmain.webp",
    alt: "Screencap of Writer Dashboard on Voice Spark."
};

//mSE
export const addScriptBtnImg = {
    src: "https://i.ibb.co/2YFWf2C/add-Script-Btn-1.gif",
    alt: "Screencapture of user adding a custom Script button to the mSE tool"
};

export const navigateTabsImg = {
   src: "https://i.ibb.co/YBN1f0c/navigate-Tabs-1.gif",
   alt: "Screencapture of user navigating between tabbed categories in mSE tool"
};

export const preBuiltToolImg = {
    src: "https://i.ibb.co/S7D9Dt5/pre-Built-Tool-1.gif",
    alt: "Screencapture of user initiating spell check tool"
};

export const mSEpreviewImg = {
    src: "https://i.ibb.co/5rSQBsC/m-SEpreview.webp",
    alt: "Screencapture of AfterEffects extension tool with title Mini SparkEffects (mSE)."
};
export const dockingImg = {
    src: "https://i.ibb.co/3FNjPyJ/docking-1.gif",
    alt: "Screencapture of user docking mSE panel vertically and horizontally."
};

//decision making tool
export const dmInfoIconImg = {
    src: "https://i.ibb.co/VYQCJYBx/dm-infoicon.webp",
    alt: "Survey screen with a pop-up informational tag."
};

export const dmQuestionImg = {
    src: "https://i.ibb.co/RGTbL6bJ/dm-question.webp",
    alt: "Survey page with question title 'On average, how often do you tend to receive care?', three answer choices, and back and next buttons."
};

export const dmResultImg = {
    src: "https://i.ibb.co/7t6KXB9c/dm-result.webp",
    alt: "Survey end screen showing a result of Preferred Provider Organization (PPO), alongside an illustration of a woman, a score placement chart, and some explanatory text."
};

export const dmResultDetailsImg = {
    src: "https://i.ibb.co/hrd7vK9/dm-resultdetails.webp",
    alt: "Survey end screen with paragraphs of various aspects to keep in mind when selecting a medical plan type."
};

export const dmStartPageImg = {
    src: "https://i.ibb.co/0R9hR4WQ/dm-startpage.webp",
    alt: "Survey start page with title 'Find your plan', paragraph of text about choosing a medical plan, illustration of a man at a laptop with a thought bubble containing two medical icons, and a start button."
};

//survey redesign
export const tvInteractiveImg = { 
      src: "https://i.ibb.co/vY1z2Lz/tv-goalsetting.webp",
      alt: "Screenshot of a webpage with the title 'Today you are going to:', the subtitles 'set a personal goal', 'identify skills to grow', and 'establish a check-in schedule', each with corresponding symbols of a target, graph, and calendar. Below is a right arrow and a progress bar."
    };

export const srAudioFeedbackImg = {
    src: "https://i.ibb.co/23sm0zWH/sr-Audio-Feedback.webp",
    alt: "Screenshot of a webpage displayed on a MacBook and iPhone with the text 'Question title: Audio feedback?' and an illustration of a woman above a purple button."
};

export const srDatePickerImg = {
    src: "https://i.ibb.co/S4d3ZN81/sr-Date-Picker-Desktop.webp",
    alt: "Survey screen with a custom date picker open."
};

export const srLinkedSliderImg = {
    src: "https://i.ibb.co/23z18Cmq/sr-Linked-Slider-Desktop.webp",
    alt: "Survey screen showing a slider-type question"
};

export const srSemanticImg = {
    src: "https://i.ibb.co/Dfw0sbkH/sr-Semantic-Differential.webp",
    alt: "Laptop computer and iPhone with screens open to a multi-select semantic differential style survey question."
};

//rgbdle
export const rgbdleImg = {
    src: "https://i.ibb.co/74TgjPx/rgbdle.png",
    alt: "Screencapture of rgbdle.page"
};

